module.exports = __webpack_public_path__ + "static/media/mulher-e-crianca.0f95af3b.jpg";